import { guidGenerator } from '../helpers/guid'

export function getElementByElementOrId(id_or_element) {
    if (typeof id_or_element === 'string') { return document.getElementById(id_or_element) };
    if ( id_or_element instanceof Element ) { return id_or_element };
    return;
}

export function identifyElement(element) {
    if (!element) { return null }
    let id = element.id;
    if (id) return id;
    do { id = 'anonymous_element_' + guidGenerator() } while ( document.getElementById(id) );
    element.id = id;
    return id;
}

export function hasChildElement(element) {
    return element.children.length !== 0;
}

// The `crumple` function is used to hide and disable an element and all of its children.
// This is useful for hiding and disabling a form element that is not needed for a particular form but that we wish to not be `display: none`.
// This is particularly useful for honeypot fields that are used to detect spam bots.
export function crumple(element) {
    // Hide and disable the element
    element.style.pointerEvents = 'none';
    element.style.position = 'absolute';
    element.style.overflow = 'hidden';
    element.style.height = '0px';
    element.style.width = '0px';

    // Ensure any child inputs can be empty and is empty
    let inputElements = element.querySelectorAll('input');
    inputElements.forEach((el) => {
        el.required = false;
        el.value = '';
    });

    // Ensure all child elements that are tabbable (can have focus) have a negative tabIndex so they can not be tabbed to.
    let focusableElements = element.querySelectorAll('button, [href], input, select, textarea, [tabindex]');
    focusableElements.forEach((el) => el.tabIndex = -1 );
}